import { Button, Card, Tabs } from "antd";
// import moment from "moment";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
// import Loading from "../../components/loading";
import PageHeaders from "../../components/pageHeaders";
import { API } from "../../config/Api";
import { GET, POST } from "../../utils/apiRequest";
// import NoData from "../components/noData";
import SettlementFormModal from "./settlmentForm";
import TicketModal from "../Tickets/ticketModal";
import { IoReload } from "react-icons/io5";
import TransViewModal from "./transViewModal";
import TicketDetails from "../../admin/jobsScreen/components/ticket";
import TransactionDetails from "../../admin/jobsScreen/components/transaction";
import CardDetails from "../../admin/jobsScreen/components/card";

const { TabPane } = Tabs;

const JobDetails = () => {
  const location = useLocation();
  const id = location.state?.val;
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isSettlmentModel, setIsSettlmentModel] = useState(false);
  const [jobData, setJobData] = useState<any>([]);
  const [ticketModal, setTicketModal] = useState<any>(false);
  const [ticketNumber, setTicketNumber] = useState<any>(false);
  const [transaction, setTransactions] = useState<any>([]);
  const [transView, setTransView] = useState<any>(false);

  const [trans_page, setTrans_page] = useState(1);
  const [trans_take, setTrans_take] = useState(10);
  const [ticket_page, setTicket_page] = useState(1);
  const [ticket_take, setTicket_take] = useState(10);

  useEffect(() => {
    getDetails();
  }, []);

  const getDetails = async (
    trans_page: any = 1,
    trans_take: any = 10,
    ticket_page: any = 1,
    ticket_take: any = 10
  ) => {
    try {
      // const api = API.JOBS_DETAILS + id;
      // let response: any = await GET(api);
      const api = API.JOBS_DETAILS_NEW;
      const obj = {
        id,
        trans_page,
        trans_take,
        ticket_page,
        ticket_take,
      };
      let response: any = await POST(api, obj);
      if (response?.status) {
        setJobData(response?.data);
        setIsLoading(false);
        setIsLoading2(false);
        walletSummary(response?.data?.job?.staffId);
      } else {
        console.log("something went wrong");
        setIsLoading(false);
        setIsLoading2(false);
      }
    } catch (err) {
      console.log("err === >", err);
      setIsLoading(false);
      setIsLoading2(false);
    }
  };

  const walletSummary = async (u_id: any) => {
    try {
      let obj = {
        staffId: u_id,
        jobId: Number(id),
      };
      let api = API.TRANSACTION_SUMMARY;
      const response: any = await POST(api, obj);
      if (response?.status) {
        setData(response?.data);
      }
    } catch (err) {
      console.log("err --- >>>", err);
    }
  };

  const totalUpi =
    data?.total?.find((item: any) => item.paymentMethod === "upi")
      ?.totalAmount || 0;

  const getTransactions = async (payMethod: any) => {
    try {
      const api = API.TRANSACTIONS_LIST;
      let obj = {
        type: null,
        paymentMethod: payMethod,
        page: 1,
        take: 100,
        user: jobData?.job?.staffId,
        jobId: jobData?.job?.id,
      };
      const response: any = await POST(api, obj);
      if (response?.status) {
        setTransactions(response.data);
        setIsLoading(false);
        setIsLoading2(false);
      } else {
        console.log("something went wrong");
        setIsLoading(false);
        setIsLoading2(false);
      }
    } catch (error) {
      console.log("error == >", error);
      setIsLoading(false);
      setIsLoading2(false);
    }
  };

  return (
    <div>
      <PageHeaders title={"Job Details"} backButton={true}>
        <div style={{ display: "flex" }}>
          {jobData?.job?.status ? (
            <Button type="primary" onClick={() => setIsSettlmentModel(true)}>
              Clock Out
            </Button>
          ) : null}
          <div style={{ marginLeft: 6 }}>
            <Button className="refreshBtn mr-3" onClick={() => getDetails()}>
              <IoReload color="#000" size={15} />
            </Button>
          </div>
        </div>
      </PageHeaders>

      <div className="screenBox">
        <Row>
          <Col>
            <Card>
              <div className="jobTxt1">Total Collection</div>
              <div className="jobTxt2">
                {data?.grandTotal ? Number(data?.grandTotal).toFixed(2) : 0}
              </div>
            </Card>
          </Col>
          <Col>
            <Card>
              <div className="jobTxt1">Total Tickets</div>
              <div className="jobTxt2">
                {jobData?.tickets?.data?.length ? jobData?.tickets?.data?.length : 0}
              </div>
            </Card>
          </Col>
          <Col>
            <Card>
              <div className="jobTxt1">Total Refund</div>
              <div className="jobTxt2">
                {data?.refundcash ? Number(data?.refundcash).toFixed(2) : 0.0}
              </div>
            </Card>
          </Col>
          <Col>
            <Card>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="jobTxt1">Total Cash</div>
                <div
                  className="ViewBtn"
                  onClick={() => {
                    setTransView(true);
                    setIsLoading2(true);
                    getTransactions("cash");
                  }}
                >
                  View
                </div>
              </div>
              <div className="jobTxt2">
                {data?.totalcash
                  ? Number(
                      Number(data?.totalcash) -
                        Number(data?.refundcash ? data?.refundcash : 0)
                    ).toFixed(2)
                  : 0}
              </div>
            </Card>
          </Col>
          <Col>
            <Card>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div className="jobTxt1">Total UPI</div>
                <div
                  className="ViewBtn"
                  onClick={() => {
                    setTransView(true);
                    setIsLoading2(true);
                    getTransactions("upi");
                  }}
                >
                  View
                </div>
              </div>
              <div className="jobTxt2">{Number(totalUpi).toFixed(2)}</div>
            </Card>
          </Col>
        </Row>

        <br />

        <Tabs defaultActiveKey="tickets" type="card">
          <TabPane tab="Tickets" key="tickets">
            <TicketDetails
              isLoading={isLoading}
              jobData={jobData}
              setTicketModal={setTicketModal}
              setTicketNumber={setTicketNumber}
              page={ticket_page}
              take={ticket_take}
              setPage={(page: any) => setTicket_page(page)}
              setTake={(take: any) => setTicket_take(take)}
              getDetails={(page: number, take: number) =>
                getDetails(trans_page, trans_take, page, take)
              }
            />
          </TabPane>
          <TabPane tab="Transactions" key="transactions">
            <TransactionDetails
              isLoading={isLoading}
              jobData={jobData}
              page={trans_page}
              take={trans_take}
              setPage={(page: any) => setTrans_page(page)}
              setTake={(take: any) => setTrans_take(take)}
              getDetails={(page: number, take: number) =>
                getDetails(page, take, ticket_page, ticket_take)
              }
            />
          </TabPane>
          <TabPane tab="Cards" key="cards">
            <CardDetails isLoading={isLoading} jobData={jobData} />
          </TabPane>
        </Tabs>
      </div>

      {/* Modals */}
      {isSettlmentModel && (
        <SettlementFormModal
          jobData={jobData}
          visible={isSettlmentModel}
          onCancel={() => {
            setIsSettlmentModel(false);
            getDetails();
          }}
          data={data}
        />
      )}
      {ticketModal && (
        <TicketModal
          view={ticketModal}
          ticketNo={ticketNumber}
          onClose={() => setTicketModal(false)}
        />
      )}
      {transView && (
        <TransViewModal
          loading={isLoading2}
          visible={transView}
          onCancel={() => setTransView(false)}
          data={transaction}
        />
      )}
    </div>
  );
};

export default JobDetails;